import { SEDERO_DATE_SUFFIX } from '~/cdnAssets'
import type { CosmosSite } from '~/constants'
import { isErosionSite, type ErosionSite } from '~/constants'
import { cdnUrl } from './cdn'

export { SEDERO_DATE_SUFFIX }

export function sederoManifestUrl(site: ErosionSite): string {
  return cdnUrl(`raster/sedero/${SEDERO_DATE_SUFFIX[site]}/${site}/sedero_manifest.json`)
}

/** Subset of sedero_manifest.json the app actually reads. */
export type SederoScenario = {
  /** e.g. "RP005_DEM020_ADAPT000" — matches useAppStore's getCosmosScenario(). */
  scenario: string
  dem: string
  rp: string
  adapt: string
  /** cdnUrl()-relative key for the EPSG:3857 browser COG. */
  web_key: string
}

export type SederoManifest = {
  manifest_version: string
  asset_root: string
  scenarios: SederoScenario[]
}

export async function fetchSederoManifest(site: CosmosSite): Promise<SederoManifest> {
  if (!isErosionSite(site)) {
    throw new Error(`No sedero manifest for ${site}`)
  }
  const response = await fetch(sederoManifestUrl(site))
  if (!response.ok) {
    throw new Error(`Sedero manifest fetch failed: ${response.status} ${response.statusText}`)
  }
  return (await response.json()) as SederoManifest
}
